import { render, staticRenderFns } from "./shuibiaojiandingjieguo.vue?vue&type=template&id=0024f828&scoped=true&"
import script from "./shuibiaojiandingjieguo.vue?vue&type=script&lang=js&"
export * from "./shuibiaojiandingjieguo.vue?vue&type=script&lang=js&"
import style0 from "./shuibiaojiandingjieguo.vue?vue&type=style&index=0&id=0024f828&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0024f828",
  null
  
)

export default component.exports